<script setup lang="ts">
import { LoaderProps } from "./Loader.props"
withDefaults(defineProps<LoaderProps>(), {
  type: "loader",
  dimensions: "small"
})
</script>

<template>
  <div class="flex h-full w-full items-center">
    <span
      :class="[
        type,
        dimensions,
        { 'h-4 w-4': dimensions === 'small' },
        { 'h-6 w-6': dimensions === 'small-medium' },
        { 'h-8 w-8': dimensions === 'medium' },
        { 'h-10 w-10': dimensions === 'medium-big' },
        { 'h-14 w-14': dimensions === 'big' },
        customDimension
      ]"
    ></span>
  </div>
</template>

<style scoped lang="scss">
.loader {
  border: 2px solid transparent;
  border-bottom-color: #247881;
  border-left-color: #247881;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1.5s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.spinner {
  border-radius: 50%;
  background: radial-gradient(farthest-side, #247881 94%, #0000) top/14.1px
      14.1px no-repeat,
    conic-gradient(#0000 70%, #247881);
  -webkit-mask: radial-gradient(
    farthest-side,
    #0000 calc(100% - 14.1px),
    #000 0
  );
  animation: spinner-c7wet2 0.8s infinite linear;
}

@keyframes spinner-c7wet2 {
  100% {
    transform: rotate(1turn);
  }
}
</style>
